// @ts-nocheck
import React from "react";
import { t } from "i18next";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import genRequest from "includes/request";
import InfosFetcher from "components/InfosFetcher/InfosFetcher";
import TagLabel from "components/Tags/Label/TagLabel";
import noAccent from "includes/no_accents";
import useAccount from "classes/Accounts/hooks/useAccount";
import ScrollTable from "components/ScrollTable/ScrollTable";
import UserImage from "components/User/Image/UserImage";
import Summary from "components/Summary/Summary";

export default function Targets(props) {
	const {postId, isTargetPost, postTypeId} = props;

	if (postTypeId === 13)
		return (<AlertTargets {...props}/>);

	const formatSiteResult = (items) => {

		let title = t(
			"Targets.published",
			{
				context: "sites",
				count: items.length
			}
		)

		let childs = items.sort((a, b) => {
			let a_name = noAccent((a.siteName + (a.address ? " - " + a.address : "")).toLocaleLowerCase());
			let b_name = noAccent((b.siteName + (b.address ? " - " + b.address : "")).toLocaleLowerCase());
			return (a_name < b_name ? -1 : 1);
		}).map((a) => {
			let name = a.siteName + (a.address ? " - " + a.address : "");
			return (
				<TagLabel key={a.id} text={name}/>
			);
		});
		return ({
			title,
			childs
		});
	};

	const formatGroupsResult = (items) => {

		let title = t(
			"Targets.published",
			{
				context: "groups",
				count: items.length
			}
		)

		let childs = items
			.sort((a, b) => (noAccent(a.groupName.toLocaleLowerCase()) < noAccent(b.groupName.toLocaleLowerCase()) ? -1 : 1))
			.map((a) => (<TagLabel text={a.groupName} key={a.id} color={a.defaultHexaColor}/>));
		return ({
			title,
			childs
		});
	};

	return (
		<>
			<InfosFetcher
				queryFn={() => genRequest("sites/post/" + postId)}
				queryKey={["Sites", "AllSiteOfPost", postId]}
				options={{
					retry: 0
				}}
				treat={(resp) => {
					if (!resp?.length || isTargetPost)
						return (false);
					let obj = formatSiteResult(resp);
					return (
						<Summary
							items={obj.childs}
							title={obj.title}
							icon={faBullseye}
						/>
					);
				}}
			/>
			<InfosFetcher
				queryFn={() => genRequest("groups/post/" + postId)}
				queryKey={["Groups", "GroupOfPost", postId]}
				options={{
					retry: 0
				}}
				treat={(resp) => {
					if (!resp?.length)
						return (false);
					let obj = formatGroupsResult(resp);
					return ((
						<Summary
							items={obj.childs}
							title={obj.title}
							icon={faBullseye}
						/>
					));
				}}
			/>
		</>
	);
}

export function AlertTargets({postId}) {
	const {account} = useAccount();
	const TargetImage = ({item}) => {
		return (<UserImage width={30} employeeId={item.id}/>);
	};

	return (
		<InfosFetcher
			queryKey={["posts", postId, "alerts"]}
			queryFn={() => genRequest("posts/" + postId + "/alerts")}
			treat={(linkeds) => {
				let title = t("Commons.TARGETS", {count: linkeds?.length}).toLowerCase();
				if (!linkeds?.length)
					return (title);
				return (
					<InfosFetcher
						queryKey={["Employes", "EmployeOfCompany", account.companyId]}
						queryFn={() => genRequest("employees/company/" + account.companyId)}
						treat={(users) => {
							let filtered = users.filter((a) => {
								return (linkeds.findIndex((link) => link.employeeId === a.id) !== -1);
							});

							return (
								<Summary
									icon={faBullseye}
									items={
										<ScrollTable
											items={filtered}
											sortBy="firstName"
											itemId="id"
											className="dark-bg"
											cellSpacing={"5px"}
											cols={[
												{
													title: " ",
													name: "targetImage",
													classes: "post-target-image-cell",
													sort: false,
													component: TargetImage
												},
												{
													title: t("User.FIRST_NAME"),
													name: "firstName",
													classes: "post-title-cell"
												},
												{
													title: t("User.LAST_NAME"),
													name: "lastName",
													classes: "post-title-cell"
												}
											]}
										/>
									}
									title={title}
								/>
							);
						}}
					/>
				);
			}}
		/>
	);
}

